<template>
    <div class="modal fade" id="ModalFeedback" tabindex="-1" role="dialog" aria-labelledby="Обратная связь"
         aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="h5 heading heading_modal" id="ModalFeedbackLabel" v-if="!message">Обратная связь</p>
                    <button type="button" class="modal-close btn btn-close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <form id="feedbackForm" method="post" action="/ajax_new/Forms/feedback/"
                          enctype="multipart/form-data" @submit.prevent="submit" v-if="!message">
                        <div class="modal-body-content">
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.fio.$error }">
                                <label for="feedbackForm_fdbFio">
                                    ФИО
                                    <span class="color-red">*</span>
                                </label>
                                <input type="text" name="FDB_FIO" id="feedbackForm_fdbFio"
                                       @blur="$v.fio.$touch()"
                                       class="form-control" v-model.trim="$v.fio.$model"
                                       :readonly="userAuthorized && $v.fio.required"/>
                                <div class="invalid-input" v-if="!$v.fio.required">
                                    Поле обязательно для заполнения
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.phone.$error }">
                                <label for="feedbackForm_fdbPhone">
                                    Телефон
                                    <span class="color-red">*</span>
                                </label>
                                <masked-input class="form-control"
                                              name="FDB_PHONE"
                                              mask="+7 (999) 999 99 99" placeholder="+7 (___) ___ __ __"
                                              type="tel"
                                              ref="maskedPhone"
                                              id="feedbackForm_fdbPhone"
                                              :value="phone"
                                              @focus="$v.phone.$reset"
                                              @blur="$v.phone.$touch"
                                              @input="setPhone"
                                              :readonly="userAuthorized && phoneValid"/>
                                <div class="invalid-input" v-if="!$v.phone.valid">
                                    Неверный номер телефона
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.email.$error }">
                                <label for="feedbackForm_fdbEmail">E-mail</label>
                                <input type="text" name="FDB_EMAIL" id="feedbackForm_fdbEmail"
                                       class="form-control" v-model.trim="email" @blur="$v.email.$touch()"
                                       @input="$v.email.$reset()"
                                       :readonly="userAuthorized && $v.email.email"/>
                                <div class="invalid-input" v-if="!$v.email.email">
                                    Неверный e-mail
                                </div>
                            </div>
                            <div class="form-group form-group_modal" :class="{ 'form-group--error': $v.text.$error }">
                                <label for="feedbackForm_fdbText">
                                    Текст обращения
                                    <span class="color-red">*</span>
                                </label>
                                <textarea class="form-control" name="FDB_TEXT" rows="5" id="feedbackForm_fdbText"
                                          @blur="$v.text.$touch()"
                                          v-model.trim="$v.text.$model">
                            </textarea>
                                <div class="invalid-input" v-if="!$v.text.required">
                                    Поле обязательно для заполнения
                                </div>
                            </div>
                        </div>
                        <div class="form-group policy-personal-data-block" v-if="!userAuthorized">
                            Нажимая на кнопку «Отправить обращение» вы подтверждаете,
                            что согласны с
                            <a href="/policy-personal-data" class="policy-data" target="_blank">
                                Политикой обработки персональных данных
                            </a>
                        </div>
                        <div class="form-group form-group_modal modal-footer">
                            <button type="submit" class="btn btn-block btn-primary" v-loading="isAjax" :disabled="isAjax">
                                Отправить обращение
                            </button>
                        </div>
                        <div class="alert alert-dismissable fade show alert-danger" role="alert"
                             v-if="errors.length">
                            {{ errors[0].message }}
                        </div>
                    </form>
                    <div v-if="message">
                        <h1 class="py-3 text-center" v-if="message">
                            {{ message }}
                        </h1>
                        <div class="form-group form-group_modal">
                            <button class="btn btn-primary btn-block" data-dismiss="modal">ОК</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, email} from 'vuelidate/lib/validators'
  import MaskedInput from '../MaskedInput'

  export default {
    name: 'feedback',
    mixins: [validationMixin],
    components: {MaskedInput},
    data: function () {
      return {
        modalId: '',
        userAuthorized: false,
        fio: '',
        phone: '',
        email: '',
        text: '',
        isAjax: false,
        message: '',
        errors: []
      }
    },
    created: function () {
      this.modalId = this.$attrs.application.modalId
      this.userAuthorized = this.$attrs.application.userAuthorized
      this.fio = this.$attrs.application.userFullName
      this.email = this.$attrs.application.userEmail

      this.phone = this.$attrs.application.userPhone.toString()

      if (this.userAuthorized) {
        this.check = true
      }
    },
    computed: {
      phoneValid() {
        return this.phone.replace(/[^0-9]/g, '').length === 11
      }
    },
    validations: {
      fio: {
        required
      },
      phone: {
        valid () {
          return this.phoneValid
        }
      },
      email: {
        email
      },
      text: {
        required
      }
    },
    methods: {
      setPhone: function (value) {
        this.phone = value
      },
      submit: async function (e) {
        this.errors = []
        this.message = ''
        this.$v.$touch()

        let targetNode = e.target
        let action = targetNode.action

        if (!this.$v.$invalid) {
          let formData = new FormData(targetNode)

          await this.$recaptchaLoaded()
          const token = await this.$recaptcha('feedback')

          formData.append('g-recaptcha-response', token)

          this.isAjax = true

          this.$http.post(action, formData).then(request => {
            this.isAjax = false
            this.$metrika.reachGoal('feedback');
            console.error('call feedback')
            if (request.data.status) {
              this.message = request.data.data.message

              this.cleanForm()
            } else {
              this.errors = request.data.errors
            }
          }).catch(error => {
            this.isAjax = false

            console.error(error)
          })
        }
      },
      cleanForm () {
        this.$v.$reset()

        if (!this.userAuthorized) {
          this.fio = ''
          this.phone = ''
          this.email = ''
        }

        this.text = ''
        this.errors = []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/forms/Feedback.vue